/**
 * This Software is the property of dotfly and is protected
 * by copyright law - it is NOT Freeware.
 *
 * Any unauthorized use of this software without a valid license key
 * is a violation of the license agreement and will be prosecuted by
 * civil and criminal law.
 *
 * @category   Makes header visible when scrolling up
 * @author     Anna Morawe <anna.morawe@dotfly.de>
 * @license    http://www.dotfly.de Commercial
 * @link       http://www.dotfly.de
 */

// https://codingreflections.com/hide-header-on-scroll-down/

/* eslint-disable */

var oScrollHeader = document.getElementsByClassName('js-scroll-header');

for (var i = 0; i < oScrollHeader.length; i++) {

    (function () {

        var doc = document.documentElement;
        var w = window;

        var prevScroll = w.scrollY || doc.scrollTop;
        var curScroll;
        var direction = 0;
        var prevDirection = 0;

        var header = document.querySelector('.js-scroll-header');

        var checkScroll = function () {

            /*
            ** Find the direction of scroll
            ** 0 - initial, 1 - up, 2 - down
            */

            curScroll = w.scrollY || doc.scrollTop;
            if (curScroll > prevScroll) {
                //scrolled up
                direction = 2;
            } else if (curScroll < prevScroll) {
                //scrolled down
                direction = 1;
            }

            if (direction !== prevDirection) {
                toggleHeader(direction, curScroll);
            }

            prevScroll = curScroll;
        };

        var toggleHeader = function (direction, curScroll) {
            if (direction === 2 && curScroll > 98) {

                header.classList.add('hide');
                prevDirection = direction;
            } else if (direction === 1) {
                header.classList.remove('hide');
                prevDirection = direction;
            }
        };

        window.addEventListener('scroll', checkScroll);

    })();

}
/* eslint-enable */
